//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let titleTextSize = '4rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
		titleTextSize = '3rem';
	}
	if (isMobile) {
		titleTextSize = '2rem';
	}
	//#endregion

	return {
		outerStyle: ({mt} = {}) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				padding: `0 ${minimumMarginX}rem 0 ${minimumMarginX}rem`,
				marginTop: mt ? '3rem' : 'unset',
			};
		},
		titleText: () => {
			return {
				color: 'black',
				fontSize: titleTextSize,
				textAlign: 'center',
			};
		},
		genericText: () => {
			return {
				marginTop: `1rem`,
			};
		},
	};
}

export default Styles;
